var App = App || {};

App.Reset = (function ($) {
	"use strict";

	function init() {
		$(document).on("submit", "form.reset-async", function (e) {
			e.preventDefault();

			const $form = $(this);
			const $summary = $("#error-summary").empty();			
			const $submitBtn = $form.find('button[type="submit"]');

			$form.find("input").each((_, el) => el.setCustomValidity(""));

			if ($form[0].checkValidity()) {
				const formData = Object.fromEntries($form.serializeArray().map(({ name, value }) => [name, value]));

				App.Spinner.startSpinner($submitBtn, "Processing");

				$.ajax({
					type: $form.attr("method") || "POST",
					url: $form.attr("action"),
					data: JSON.stringify(formData),
					contentType: 'application/json; charset=utf-8'
				}).done(function (response, textStatus, jqXHR) {
					if (!response) {
						$summary.text("Unable to process reset request. Try again later.");
						return;
					};

					if (!response.success) {
						$summary.text(response?.message || "Email address not found.  Please verify your email address or call 617-226-1570 or contact support@socialaw.com.");
					}

					if (response.success) {
						$summary.text(response?.message || "Reset request has been processed. Please check your email for further instructions.");
					} else {
						$summary.text("Email address not found.  Please verify your email address or call 617-226-1570 or contact support@socialaw.com.");
					}

				}).fail(function (jqXHR) {
					$summary.text("Unable to process reset request. Try again later.");
				})
			   .always(function () {
						
				 App.Spinner.stopSpinner($submitBtn);
				});
			} else {
				applyValidationMessages($form);
			}

			$form.addClass("was-validated");
		});

		$(document).on("submit", "form.reset-submit-async", function (e) {
			e.preventDefault();

			const $form = $(this);
			const $summary = $form.find(".form-validation-message").empty();
			const $pwd = $form.find("#password");
			const $confirm = $form.find("#password-confirm");
			const $submitBtn = $form.find('button[type="submit"]');

			$form.find("input").each((_, el) => el.setCustomValidity(""));

			if ($pwd.val() && $confirm.val() && $pwd.val() !== $confirm.val()) {
				$confirm[0].setCustomValidity("Passwords do not match.");
			}

			if ($form[0].checkValidity()) {
				const formData = Object.fromEntries($form.serializeArray().map(({ name, value }) => [name, value]));

				App.Spinner.startSpinner($submitBtn, "Processing");

				$.ajax({
					type: $form.attr("method") || "POST",
					url: $form.attr("action"),
					data: JSON.stringify(formData),
					contentType: 'application/json; charset=utf-8'
				}).done(function (response, textStatus, jqXHR) {
					if (!response) {
						$summary.text("Unable to process reset request. Try again later.");
						return;
					};

					let identityResponse = response.data;

					if (!response.success) {
						$summary.text(identityResponse?.errors[0]?.description || response?.message || "Unable to process reset request. Try again later.");
					}

					if (response.success && response.data) {
						if (!identityResponse.succeeded) {
							$summary.text(identityResponse?.errors[0]?.description || "Unable to process reset request. Try again later.");
						}
						else {
							
								const loginUrl = "/account/login/?returnUrl=%2F"; 

								$summary							
									.empty()
									.append(document.createTextNode("Your password has been changed. "))
									.append(
										$("<a>", {
											href: loginUrl,
											text: "Click here to return to login",
											"aria-label": "Click here to return to login page"
										})
									)
									.append(".");
							

							
						}
					}
				}).fail(function (jqXHR) {
					$summary.text("Unable to process reset request. Try again later.");
				})
			    .always(function () {
                  	App.Spinner.stopSpinner($submitBtn);
			    });
			} else {
				applyValidationMessages($form);
			}

			$form.addClass("was-validated");
		});
	}

	function applyValidationMessages($form) {
		$form.find(":invalid").each(function () {
			let msg = "";

			switch (true) {
				case this.validity.valueMissing:
					msg = $(this).data("val-required") || "A value is required.";
					break;
				case this.validity.typeMismatch:
					msg = $(this).data("val-type") || "Incorrect format.";
					break;
				default:
					msg = this.validationMessage || "";
					break;
			}

			$(this).siblings(".field-validation-error").text(msg);
		});
	}

	return {
		init: init
	};

})(jQuery);

$(function () {
	App.Reset.init();
});